import { render, staticRenderFns } from "./team-stats-deck.vue?vue&type=template&id=1aef01a8&scoped=true&"
import script from "./team-stats-deck.vue?vue&type=script&lang=js&"
export * from "./team-stats-deck.vue?vue&type=script&lang=js&"
import style0 from "./team-stats-deck.vue?vue&type=style&index=0&id=1aef01a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef01a8",
  null
  
)

export default component.exports